<template>
	<div
		class="component c-navigation"
		:class="{ dark: this.$root.navigation.dark_mode }"
	>
		<div
			class="c-navigation__app-bar border-b bp-1024:border-b-none bp-1024:border-l height-100 padding-r-6 bp-1024:padding-r-0 bp-1024:padding-t-32 position-relative d-flex flex-direction-row-reverse bp-1024:flex-direction-column justify-content-between bp-1024:justify-content-center align-items-center"
		>
			<button
				role="button"
				class="c-navigation__menu-button margin-r-12 flex-shrink-0 bp-1024:margin-b-12 bp-1024:margin-r-0"
				:aria-expanded="is_menu_open"
				aria-label="Toggle main navigation menu"
				:class="is_menu_open ? 'is-active' : ''"
				@click="toggle_menu"
				tabindex="0"
			>
				<span class="line-1"></span>
				<span class="line-2"></span>
				<span class="line-3"></span>
			</button>
			<div
				class="c-navigation__offcanvas s-common__scrollbar position-fixed"
				:class="is_menu_open ? 'is-open' : ''"
				@keyup.esc="close_menu"
			>
				<ul
					class="margin-y-auto c-navigation__items reset-list d-flex flex-direction-column"
				>
					<template v-for="link in links">
						<li
							:key="link.url"
							class="c-navigation__item c-navigation__item--level-1 border-b position-relative"
						>
							<a
								class="d-flex justify-content-end  align-items-center padding-y-40 bp-1024:padding-y-48 padding-x-32 bp-1024:padding-x-48 c-navigation__url c-navigation__url--level-1 text-decoration-none "
								:class="
									current_section === link.url
										? 'is-active'
										: ''
								"
								@click.prevent="scroll_to(link.url)"
								:title="
									link.navMenuText
										? link.navMenuText
										: link.title
								"
								:tabindex="is_menu_open ? 0 : -1"
								:href="link.url"
								@focus="is_menu_open = true"
								@blur="is_menu_open = false"
								role="button"
							>
								<feather
									class="margin-r-48 font-size-36 bp-1024:font-size-48 line-height-1 c-navigation__url-icon"
									size="36"
									stroke-width="1"
									:type="
										icons[link.icon]
											? icons[link.icon]
											: 'arrow-right'
									"
								></feather>

								<span
									class=" margin-l-auto font-weight-bold text-transform-uppercase text-align-right font-size-21 bp-1024:font-size-30 line-height-125"
									>{{
										link.navMenuText
											? link.navMenuText
											: link.title
									}}</span
								>
							</a>
						</li>
					</template>
					<template v-for="link in more_links">
						<li
							:key="link.url"
							class="c-navigation__item c-navigation__item--level-1 border-b position-relative"
						>
							<a
								class="d-flex justify-content-end  align-items-center padding-y-40 bp-1024:padding-y-48 padding-x-32 bp-1024:padding-x-48 c-navigation__url c-navigation__url--level-1 text-decoration-none "
								:title="link.title"
								:tabindex="is_menu_open ? 0 : -1"
								:href="link.url"
								@focus="is_menu_open = true"
								@blur="is_menu_open = false"
								role="button"
								target="_blank"
							>
								<feather
									class="margin-r-48 font-size-36 bp-1024:font-size-48 line-height-1 c-navigation__url-icon"
									size="36"
									stroke-width="1"
									type="external-link"
								></feather>
								<span
									class=" margin-l-auto font-weight-bold text-transform-uppercase text-align-right font-size-21 bp-1024:font-size-30 line-height-125"
									>{{ link.title }}</span
								>
							</a>
						</li>
					</template>
					<li
						:key="continue_url"
						class="c-navigation__item c-navigation__item--level-1 border-b position-relative"
					>
						<a
							class="d-flex justify-content-end  align-items-center padding-y-40 bp-1024:padding-y-48 padding-x-32 bp-1024:padding-x-48 c-navigation__url c-navigation__url--level-1 text-decoration-none "
							:title="continue_text"
							:tabindex="is_menu_open ? 0 : -1"
							:href="continue_url"
							@focus="is_menu_open = true"
							@blur="is_menu_open = false"
							role="button"
						>
							<feather
								class="margin-r-48 font-size-36 bp-1024:font-size-48 line-height-1 c-navigation__url-icon"
								size="36"
								stroke-width="1"
								type="chevrons-right"
							></feather>
							<span
								class=" margin-l-auto font-weight-bold text-transform-uppercase text-align-right font-size-21 bp-1024:font-size-30 line-height-125"
								>{{ continue_text }}</span
							>
						</a>
					</li>
				</ul>
			</div>
			<ul
				class="margin-y-auto c-navigation__menu-dot-items reset-list flex-shrink-1 flex-wrap-wrap align-items-center d-none bp-1024:d-flex flex-direction-column"
			>
				<li v-for="link in links" :key="link.url" class="margin-y-4">
					<a
						class="c-navigation__menu-dot-item"
						:data-title="link.title"
						@click.prevent="scroll_to(link.url)"
						:title="link.title"
						:href="link.url"
						tabindex="0"
					>
						<span
							class="c-navigation__menu-dot"
							:class="
								current_section === link.url ? 'is-active' : ''
							"
						></span>
					</a>
				</li>
			</ul>
			<div
				class="c-navigation__site flex-shrink-1 position-relative d-none bp-1024:d-block"
			>
				<a
					class="text-decoration-none hover:text-decoration-underline font-weight-bold font-size-14"
					:href="continue_url"
					>{{ site_url }}</a
				>
			</div>
			<div
				v-if="logo_image"
				class="c-navigation__logo margin-x-24 1024:margin-x-0 bp-1024:margin-t-24 bp-1024:margin-b-32 bp-1024:padding-b-4"
			>
				<a :href="continue_url"
					><img :src="logo_image + '?width=100'" :alt="logo_title"
				/></a>
			</div>
		</div>
	</div>
</template>

<script>
import Navigation from './navigation';

export default {
	extends: Navigation,
	data: () => ({
		mobile_offset: -60,
		desktop_offset: -0,
	}),
};
</script>

<style scoped lang="scss">
.c-navigation {
	position: fixed;
	top: 0;
	right: 0;
	height: 100%;
	width: 100px;
	z-index: 99;
	&__app-bar {
		background: $main-color;
		border-left-color: $main-border-color;
		z-index: 2;
		&::after {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			content: '';
			background: $main-color;
			z-index: 0;
			box-shadow: -1px 0px 0px 0px $main-border-color;
		}
	}
	&__menu-button {
		@include base_reset();
		color: $color-safe-text;
		width: 48px;
		height: 48px;
		position: relative;
		z-index: 2;
		transition: 0.3s;
		cursor: pointer;
		.line-1,
		.line-2,
		.line-3 {
			position: absolute;
			width: 36px;
			height: 2px;
			background: $color-safe-text;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			transition: 0.3s;
		}
		.line-1 {
			transform: translate(-6px, -13px);
			width: 24px;
		}
		.line-2 {
			transform: translate(-6px, 12px);
			width: 24px;
		}
		.line-3 {
			opacity: 1;
		}

		&:hover {
			background: $color-primary;
			.line-1,
			.line-2,
			.line-3 {
				background: $text-on-primary;
			}
		}

		&.is-active {
			.line-1 {
				width: 36px;
				transform: translate(-50%, -50%) rotate(45deg);
			}
			.line-2 {
				transform: translate(-50%, -50%) rotate(-45deg);
				width: 36px;
			}
			.line-3 {
				opacity: 0;
			}
		}
	}
	&__menu-dot-items {
		min-height: 1px;
		width: 52px;
	}
	&__menu-dot-item {
		position: relative;
		display: block;
		&::before {
			position: absolute;
			top: 50%;
			right: 100%;
			content: attr(data-title);
			background: $color-primary;
			color: $text-on-primary;
			white-space: nowrap;
			z-index: 3;
			pointer-events: none;
			transform: translate(-24px, -50%);
			opacity: 0;
			height: 1.5rem;
			line-height: 1.5rem;
			font-size: 0.875rem;
			padding: 0 0.75rem;
			border-radius: 0.75rem;
		}

		&:hover,
		&:focus {
			&::before {
				transition: 0.3s;
				opacity: 1;
				transform: translate(0, -50%);
			}
		}
	}
	&__menu-dot {
		display: inline-block;
		width: 26px;
		height: 26px;
		position: relative;
		z-index: 2;
		&:before {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 14px;
			height: 14px;
			transform: translate(-50%, -50%);
			content: '';
			border: solid 1px $main-font-color;
			border-radius: 50%;
			opacity: 0;
		}
		&::after {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			content: '';
			background: $main-font-color;
		}
		&.is-active {
			&::after {
				background: $color-safe-text;
			}
			&::before {
				border-color: $color-safe-text;
				opacity: 1;
			}
		}
	}
	&__site {
		writing-mode: vertical-lr;
		position: relative;
		min-height: 1px;
		z-index: 2;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		padding: 48px 0;
		&::before,
		&::after {
			position: absolute;
			right: 50%;
			top: 0;
			width: 1px;
			height: 36px;
			content: '';
			background: $main-font-color;
		}
		&::after {
			top: auto;
			bottom: 0;
		}
	}
	&__logo {
		width: 50px;
		height: 50px;
		position: relative;
		z-index: 2;
		img {
			max-height: 100%;
		}
	}
	&__offcanvas {
		top: 0;
		right: 100px;
		transform: translateX(calc(100% + 2px));
		z-index: -2;
		transition: 0.3s;
		height: 100%;
		width: calc(100% - 100px);
		max-width: 740px;
		background: $main-color;
		overflow: auto;
		&.is-open {
			transform: none;
		}
	}
	&__items {
		border-left: solid 1px $main-border-color;
		min-height: 100%;
	}
	&__item--level-1 {
		border-bottom-color: $main-border-color;
	}
	&__url--level-1 {
		color: $main-font-color;
		&::before {
			position: absolute;
			top: 0;
			left: -1px;
			height: 100%;
			width: 3px;
			content: '';
			background: $color-primary;
			opacity: 0;
		}
		&.is-active {
			color: $color-safe-text;
			background: $main-gray-color;
			&::before {
				opacity: 1;
			}
		}
		&:hover,
		&:focus {
			color: $text-on-primary;
			transition: 0.2s;
			background: $color-primary;
			.c-navigation__url-icon {
				color: $text-on-primary;
			}
		}
	}
	&__url-icon {
		color: $color-primary;
	}
	@media screen and (max-width: 1023px) {
		height: 60px;
		width: 100%;
		&__app-bar {
			&::after {
				box-shadow: 0px 1px 0px 0px $main-border-color;
			}
		}
		&__offcanvas {
			right: 0;
			top: 60px;
			transform: translateY(-102%);
			height: calc(100% - 60px);
			width: 100%;
			max-width: none;
		}
		&__items {
			border-left: none;
		}
	}

	@media screen and (max-height: 600px) {
		&__site {
			padding: 12px 0;
			&::before,
			&::after {
				display: none;
			}
		}
	}
}
</style>
